import { Component, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard-cctv-novideo',
  templateUrl: './dashboard-cctv-novideo.component.html',
  styleUrls: ['./dashboard-cctv-novideo.component.scss']
})
export class DashboardCctvNovideoComponent implements OnInit {
  selected_value: any;
  cctvnovideo: any[] = [];
  show: boolean = true;
  filterBy: any;
  id: any;
  searchkey: string = '';
  public searchTerm: string = '';
  hide: boolean = false;
  constructor(public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.cctvcameranovideo();
  }
  cctvcameranovideo() {
    this.spinner.show();
    this.selected_value = "STATE"
    this.campuscctvserviceservice.getcctvnovideo(this.selected_value).subscribe((res) => {
      this.cctvnovideo = res;
      this.spinner.hide();
    });
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });
  }

  onOptionsSelected(e: any) {
    this.show = true
    this.spinner.show();
    this.selected_value = e.target.value
    if (this.selected_value === 'STATE' || this.selected_value === 'CITY' || this.selected_value === 'CAMPUS') {
      this.campuscctvserviceservice.getcctvnovideo(this.selected_value).subscribe((res) => {
        this.cctvnovideo = res;
        this.hide = false;
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigatertochange(data: any) {
    console.log(data);
    this.filterBy = data.filterBy
    this.id = data.id;
    this.spinner.show();
    if (this.filterBy == "STATE") {
      localStorage.setItem('stateId', data.id);
      this.campuscctvserviceservice.getnovideoright(this.filterBy, this.id).subscribe((res) => {
        if (res == null) {
          this.cctvnovideo = [];
          
        } else {
          console.log(res);
          this.cctvnovideo = res;
          this.spinner.hide();
          this.hide = true;
        }

      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    } else if (this.filterBy == "CITY") {
      localStorage.setItem('cityId', data.id);
      this.spinner.show();
      this.campuscctvserviceservice.getnovideoright(this.filterBy, this.id).subscribe((res) => {
        console.log(res);
        if (res == null) {
          this.cctvnovideo = [];
          this.spinner.hide();
        } else {
          this.cctvnovideo = res;
          this.hide = true;
        
        }

      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
    else if (this.filterBy == "CAMPUS") {
      localStorage.setItem('campusId', data.id);
      this.show = false;
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;


      });
      this.search({ event: { target: { value: '' } } });
    }
  }

  navigateBackward(data: any) {
    const filterBy = data.filterBy
    const id = data.id;
    this.spinner.show();
    if (filterBy == 'CAMPUS' && this.show == false) {
      this.campuscctvserviceservice.getnovideoright("CITY", localStorage.getItem('cityId')).subscribe((res) => {
        this.cctvnovideo = res;
        this.spinner.hide();
        this.show = true;
        console.log(res);
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
      if (this.selected_value === "CAMPUS") {
        this.spinner.show();
        this.hide = false;

        this.campuscctvserviceservice.getcctvnovideo(this.selected_value).subscribe((res) => {
          this.cctvnovideo = res;
          this.spinner.hide();
        });
      }

    } else if (filterBy == 'CAMPUS' && this.show == true) {
      if (localStorage.getItem('stateId')) {
        this.spinner.show();
        this.campuscctvserviceservice.getnovideoright("STATE", localStorage.getItem('stateId')).subscribe((res) => {
          this.cctvnovideo = res;
          console.log(res);
          this.spinner.hide();
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      else {
        this.spinner.show();
        this.campuscctvserviceservice.getcctvnovideo(this.selected_value).subscribe((res) => {
          // localStorage.setItem('stateId', res.id);
          this.cctvnovideo = res;
          console.log(this.cctvnovideo);
          this.spinner.hide();
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      if (this.selected_value === "CITY") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvnovideo(this.selected_value).subscribe((res) => {
          this.cctvnovideo = res;
          this.spinner.hide();
        });

      }
    }
    else if (filterBy == "CITY") {
      this.hide = false;
      this.cctvcameranovideo();
    }

  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }
}
